<mat-list-item [ngClass]="{expanded: isExpanded}" (click)="onItemSelected(item)" class="menu-list-item">
    <span class="hide-menu">{{ item.parentCategory}}</span>

    <span class="arrow-icon" fxFlex *ngIf="item.listCategory && item.listCategory.length">
        <span fxFlex></span>
        <mat-icon [ngClass]="{'rotated' : showSubmenu}">
            expand_more
        </mat-icon>
    </span>
</mat-list-item>

<div *ngIf="isExpanded && item.listCategory && item.listCategory.length">
    <mat-list-item *ngFor="let category of item.listCategory;let i = index;" [ngClass]="{expanded: isExpanded}" class="menu-list-item">
        <a mat-list-item (click)="ShowProducts(category.id)" [ngClass]="{active:selectedCategoryId===category.id || i === 0}">
            <span class="spanLink"> {{category.categoryName}}</span>
        </a>
    </mat-list-item>
</div>